import moment from "moment";

// eslint-disable-next-line complexity
export function tooltipTitle(context) {
	let label = "";
	if (context[0].datasetIndex === 0) {
		// dataset 0: selected period
		label = context[0].label;

		if (this.activePeriod === "month") label = label.replaceAll("/", ".") || "";
		else if (this.activePeriod === "week") {
			// format of label: Tuesday, 01.02.2022
			const splittedLabel = label.split(","),
				lettersOfDay = 2;
			label = splittedLabel[0].slice(0, lettersOfDay) + ". " + splittedLabel[1];
		} else if (this.activePeriod === "year") {
			// format of label: February 2022
			label = label.split(" ")[0];
		}
	}
	return label;
}

// eslint-disable-next-line complexity
export function tooltipClick(event) {
	const chart = this.$data._chart,
		activePoint = chart.getElementAtEvent(event);

	if (this.activePeriod !== "day" && activePoint.length && activePoint[0]._datasetIndex === 0) {
		const _date = chart.data.labels[activePoint[0]._index];
		let date;

		switch (this.activePeriod) {
			case "month":
				// format of date: Tu. 01/02/2022
				date = moment(_date.split(" ")[1], "DD/MM/YYYY");
				this.selectPeriod("day");
				break;

			case "week":
				// format of date: ['Tuesday', '01.02.2022']
				date = moment(_date[1], "DD.MM.YYYY");
				this.selectPeriod("day");
				break;

			case "year":
				// format of date: February 2022
				date = moment(_date, "MMMM YYYY");
				this.selectPeriod("month");
				break;
		}
		this.setActiveDate(date);

		this.$eventBus.$emit("setCalendar");
		this.$eventBus.$emit("reloadComponentData");
	}
}

export function tooltipHover(event) {
	if (this.activePeriod === "day") event.target.style.cursor = "default";
	else {
		const chart = this.$data._chart,
			activePoint = chart.getElementAtEvent(event);

		event.target.style.cursor = activePoint.length && activePoint[0]._datasetIndex === 0 ? "pointer" : "default";
	}
}
